const _excluded = ["placeholder", "separator", "isLastChild", "inputStyle", "focus", "isDisabled", "isBottomInput", "hasErrored", "errorStyle", "focusStyle", "disabledStyle", "shouldAutoFocus", "isInputNum", "index", "value", "className", "isInputSecure"];
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.symbol.description.js";
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React, { Component, PureComponent } from 'react';

// Original lib:
// https://www.npmjs.com/package/react-otp-input
// https://github.com/devfolioco/react-otp-input
// Make it ours to improve it and make some fixes
// TODO We should rework it to FC React components instead of classes
const isStyleObject = obj => typeof obj === 'object';
class SingleOtpInput extends PureComponent {
  constructor(props) {
    super(props);
    // this.input = React.createRef<HTMLInputElement>();
    _defineProperty(this, "input", /*#__PURE__*/React.createRef());
    _defineProperty(this, "getClasses", (...classes) => classes.filter(c => !isStyleObject(c) && c !== false).join(' '));
    _defineProperty(this, "getType", () => {
      const {
        isInputSecure,
        isInputNum
      } = this.props;
      if (isInputSecure) {
        return 'password';
      }
      if (isInputNum) {
        return 'tel';
      }
      return 'text';
    });
  }

  // Focus on first render
  // Only when shouldAutoFocus is true
  componentDidMount() {
    const {
      focus,
      shouldAutoFocus
    } = this.props;
    const {
      current: inputEl
    } = this.input;
    if (inputEl && focus && shouldAutoFocus) {
      inputEl.focus();
    }
  }
  componentDidUpdate(prevProps) {
    const {
      focus
    } = this.props;
    const {
      current: inputEl
    } = this.input;

    // Check if focusedInput changed
    // Prevent calling function if input already in focus
    if (prevProps.focus !== focus && inputEl && focus) {
      inputEl.focus();
      inputEl.select();
    }
  }
  render() {
    const _this$props = this.props,
      {
        placeholder,
        separator,
        isLastChild,
        inputStyle,
        focus,
        isDisabled,
        isBottomInput,
        hasErrored,
        errorStyle,
        focusStyle,
        disabledStyle,
        shouldAutoFocus,
        isInputNum,
        index,
        value,
        className,
        isInputSecure
      } = _this$props,
      rest = _objectWithoutProperties(_this$props, _excluded);
    return /*#__PURE__*/React.createElement("div", {
      className: className,
      style: {
        display: 'flex',
        alignItems: 'center'
      }
    }, /*#__PURE__*/React.createElement("input", _extends({
      "aria-label": `${index === 0 ? 'Please enter verification code. ' : ''}${isInputNum ? 'Digit' : 'Character'} ${index + 1}`,
      autoCapitalize: "none",
      autoComplete: "off",
      style: Object.assign({
        width: '1em',
        textAlign: 'center'
      }, isStyleObject(inputStyle) && inputStyle, focus && isStyleObject(focusStyle) && focusStyle, isDisabled && isStyleObject(disabledStyle) && disabledStyle, hasErrored && isStyleObject(errorStyle) && errorStyle),
      placeholder: placeholder,
      className: this.getClasses(inputStyle, focus && focusStyle, isDisabled && disabledStyle, hasErrored && errorStyle, isBottomInput && 'form-control-bottom'),
      type: this.getType(),
      maxLength: 1,
      ref: this.input,
      disabled: isDisabled,
      value: value ? value : ''
    }, rest)), !isLastChild && separator);
  }
}
export class OtpInput extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      activeInput: 0
    });
    _defineProperty(this, "getOtpValue", () => this.props.value ? this.props.value.toString().split('') : []);
    _defineProperty(this, "getPlaceholderValue", () => {
      const {
        placeholder,
        numInputs
      } = this.props;
      if (typeof placeholder === 'string') {
        if (placeholder.length === numInputs) {
          return placeholder;
        }
        if (placeholder.length > 0) {
          console.error('Length of the placeholder should be equal to the number of inputs.');
        }
      }
    });
    // Helper to return OTP from input
    _defineProperty(this, "handleOtpChange", otp => {
      const {
        onChange
      } = this.props;
      const otpValue = otp.join('');
      onChange(otpValue);
    });
    _defineProperty(this, "isInputValueValid", value => {
      const isTypeValid = this.props.isInputNum ? !isNaN(parseInt(value, 10)) : typeof value === 'string';
      return isTypeValid && value.trim().length === 1;
    });
    // Focus on input by index
    _defineProperty(this, "focusInput", input => {
      const {
        numInputs
      } = this.props;
      const activeInput = Math.max(Math.min(numInputs - 1, input), 0);
      this.setState({
        activeInput
      });
    });
    // Focus on next input
    _defineProperty(this, "focusNextInput", () => {
      const {
        activeInput
      } = this.state;
      this.focusInput(activeInput + 1);
    });
    // Focus on previous input
    _defineProperty(this, "focusPrevInput", () => {
      const {
        activeInput
      } = this.state;
      this.focusInput(activeInput - 1);
    });
    // Change OTP value at focused input
    _defineProperty(this, "changeCodeAtFocus", value => {
      const {
        activeInput
      } = this.state;
      const otp = this.getOtpValue();
      otp[activeInput] = value[0];
      this.handleOtpChange(otp);
    });
    // Handle pasted OTP
    _defineProperty(this, "handleOnPaste", e => {
      e.preventDefault();
      const {
        activeInput
      } = this.state;
      const {
        numInputs,
        isDisabled
      } = this.props;
      if (isDisabled) {
        return;
      }
      const otp = this.getOtpValue();
      let nextActiveInput = activeInput;

      // Get pastedData in an array of max size (num of inputs - current position)
      const pastedData = e.clipboardData.getData('text/plain').slice(0, numInputs - activeInput).split('');

      // Paste data from focused input onwards
      for (let pos = 0; pos < numInputs; ++pos) {
        if (pos >= activeInput && pastedData.length > 0) {
          otp[pos] = pastedData.shift();
          nextActiveInput++;
        }
      }
      this.setState({
        activeInput: nextActiveInput
      }, () => {
        this.focusInput(nextActiveInput);
        this.handleOtpChange(otp);
      });
    });
    _defineProperty(this, "handleOnChange", e => {
      const {
        value
      } = e.target;
      if (this.isInputValueValid(value)) {
        this.changeCodeAtFocus(value);
      }
    });
    // Handle cases of backspace, delete, left arrow, right arrow, space
    _defineProperty(this, "handleOnKeyDown", e => {
      if (e.key === 'Backspace') {
        e.preventDefault();
        this.changeCodeAtFocus('');
        this.focusPrevInput();
      } else if (e.key === 'Delete') {
        e.preventDefault();
        this.changeCodeAtFocus('');
      } else if (e.key === 'ArrowLeft') {
        e.preventDefault();
        this.focusPrevInput();
      } else if (e.key === 'ArrowRight') {
        e.preventDefault();
        this.focusNextInput();
      } else if (e.key === ' ' || e.key === 'Spacebar' || e.key === 'Space') {
        e.preventDefault();
      }
    });
    // The content may not have changed, but some input took place hence change the focus
    _defineProperty(this, "handleOnInput", e => {
      if (this.isInputValueValid(e.target.value)) {
        this.focusNextInput();
      } else {
        // This is a workaround for dealing with keyCode "229 Unidentified" on Android.

        if (!this.props.isInputNum) {
          const {
            nativeEvent
          } = e;
          if (nativeEvent.data === null && nativeEvent.inputType === 'deleteContentBackward') {
            e.preventDefault();
            this.changeCodeAtFocus('');
            this.focusPrevInput();
          }
        }
      }
    });
    _defineProperty(this, "renderInputs", () => {
      const {
        activeInput
      } = this.state;
      const {
        numInputs,
        inputStyle,
        focusStyle,
        separator,
        isDisabled,
        disabledStyle,
        hasErrored,
        errorStyle,
        shouldAutoFocus,
        isInputNum,
        isInputSecure,
        className,
        isBottomInput
      } = this.props;
      const inputs = [];
      const otp = this.getOtpValue();
      const placeholder = this.getPlaceholderValue();
      const dataCy = this.props['data-cy'];
      const dataTestId = this.props['data-testid'];
      for (let i = 0; i < numInputs; i++) {
        inputs.push( /*#__PURE__*/React.createElement(SingleOtpInput, {
          placeholder: placeholder && placeholder[i],
          key: i,
          index: i,
          focus: activeInput === i,
          value: otp && otp[i],
          onChange: this.handleOnChange,
          onKeyDown: this.handleOnKeyDown,
          onInput: this.handleOnInput,
          onPaste: this.handleOnPaste,
          onFocus: e => {
            this.setState({
              activeInput: i
            });
            e.target.select();
          },
          onBlur: () => this.setState({
            activeInput: -1
          }),
          separator: separator,
          inputStyle: inputStyle,
          focusStyle: focusStyle,
          isLastChild: i === numInputs - 1,
          isDisabled: isDisabled,
          disabledStyle: disabledStyle,
          hasErrored: hasErrored,
          errorStyle: errorStyle,
          shouldAutoFocus: shouldAutoFocus,
          isInputNum: isInputNum,
          isInputSecure: isInputSecure,
          className: className,
          isBottomInput: isBottomInput,
          "data-cy": dataCy && `${dataCy}-${i}`,
          "data-testid": dataTestId && `${dataTestId}-${i}`
        }));
      }
      return inputs;
    });
  }
  render() {
    const {
      containerStyle
    } = this.props;
    return /*#__PURE__*/React.createElement("div", {
      style: Object.assign({
        display: 'flex'
      }, isStyleObject(containerStyle) && containerStyle),
      className: !isStyleObject(containerStyle) ? containerStyle : ''
    }, this.renderInputs());
  }
}
_defineProperty(OtpInput, "defaultProps", {
  numInputs: 4,
  onChange: otp => {},
  isDisabled: false,
  shouldAutoFocus: false,
  value: '',
  isInputSecure: false,
  isBottomInput: false
});